/**
 * Static news, blog, and team content + image paths under /public/images/static/
 * Rates, apply forms, and contact messages remain API-driven.
 */

import { PHONE_MOBILE_DISPLAY } from "../constants/contact";

export type StaticNewsItem = {
  _id: string;
  heading: string;
  description: string;
  image: string;
};

export type StaticBlogItem = {
  id: string;
  title: string;
  description: string;
  image: string;
};

export type StaticTeamMember = {
  _id: string;
  name: string;
  designation: string;
  email: string;
  /** Mobile */
  phone: string;
  /** Office */
  officePhone?: string;
  license: string;
  image: string;
  description?: string;
};

export const STATIC_NEWS: StaticNewsItem[] = [
  {
    _id: "news-1",
    heading: "Understanding mortgage rates in Ontario",
    description:
      "<p>Whether you are buying your first home or refinancing, staying informed about current mortgage trends helps you plan with confidence.</p>",
    image: "/images/static/news/news-1.jpg",
  },
  {
    _id: "news-2",
    heading: "Tips for a smoother home financing experience",
    description:
      "<p>Organizing your documents early and working with a licensed broker can shorten approval times and reduce stress.</p>",
    image: "/images/static/news/news-2.jpg",
  },
  {
    _id: "news-3",
    heading: "Planning your next property investment",
    description:
      "<p>From rental properties to renewals, we help you evaluate options that align with your long-term goals.</p>",
    image: "/images/static/news/news-3.jpg",
  },
];

export const STATIC_BLOGS: StaticBlogItem[] = [
  {
    id: "blog-1",
    title: "How equity can support your financial goals",
    description:
      "<p>Home equity can be a flexible tool when used responsibly. Learn how different products compare before you decide.</p>",
    image: "/images/static/blog/blog-1.jpg",
  },
  {
    id: "blog-2",
    title: "First-time buyers: what to expect at closing",
    description:
      "<p>Closing costs, insurance, and final paperwork — a concise checklist so you know what is coming.</p>",
    image: "/images/static/blog/blog-2.jpg",
  },
  {
    id: "blog-3",
    title: "Refinancing: when it makes sense",
    description:
      "<p>Lower payments, debt consolidation, or accessing cash — refinancing is not one-size-fits-all.</p>",
    image: "/images/static/blog/blog-3.jpg",
  },
];

export const STATIC_TEAM_DIRECTORS: StaticTeamMember[] = [
  {
    _id: "static-director-1",
    name: "Chirag Khurana",
    designation: "Principal Broker",
    email: "info@alpham.ca",
    phone: PHONE_MOBILE_DISPLAY,
    // officePhone: PHONE_OFFICE_DISPLAY,
    license: "FSRA#13820",
    image: "/images/avatar.png",
    description:
      "Leads strategy and compliance for Alpha Mortgages, with a focus on transparent advice and long-term client relationships.",
  },
];

export const STATIC_TEAM_MANAGERS: StaticTeamMember[] = [
  /*{
    _id: "static-manager-1",
    name: "Sarah Mitchell",
    designation: "Sales Manager",
    email: "info@alpham.ca",
    phone: "905-216-0061",
    license: "M08001234",
    image: "/images/static/team/team-consultant.jpeg",
    description:
      "Supports brokers and clients through complex files, from self-employed borrowers to rental portfolios.",
  },*/
];

export const STATIC_TEAM_AGENTS: StaticTeamMember[] = [
  /*{
    _id: "static-agent-1",
    name: "James Porter",
    designation: "Mortgage Agent",
    email: "info@alpham.ca",
    phone: "905-216-0061",
    license: "M12005678",
    image: "/images/static/team/team-advisor.png",
    description:
      "Focused on first-time buyers and renewals, with clear explanations at every step.",
  },
  {
    _id: "static-agent-2",
    name: "Alex Rivera",
    designation: "Mortgage Agent",
    email: "info@alpham.ca",
    phone: "905-216-0061",
    license: "M12009900",
    image: "/images/static/team/team-placeholder.png",
    description:
      "Helps investors and self-employed clients structure applications that fit their business income.",
  },*/
];

export function getStaticNewsById(id: string): StaticNewsItem | undefined {
  return STATIC_NEWS.find((n) => n._id === id);
}

export function getStaticBlogById(id: string): StaticBlogItem | undefined {
  return STATIC_BLOGS.find((b) => b.id === id);
}
